import React from 'react';
import { Col, Flex, Typography, Tag } from 'antd';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import { GenericModal } from '../../../../../shared/ui/GenericModal';
import * as S from '../styles/autobroadcast.styles';
import { useAppSelector } from '../../../../../store';
import { selectAutoBroadcast } from '../store/autoBroadcastsSlice';

const { Text } = Typography;

interface ModalDataField {
    label: string;
    value: string | Date;
    type: 'text' | 'date';
}
export const AutoBroadcastModal = () => {
    const { current } = useAppSelector(selectAutoBroadcast);
    const navigate = useNavigate();

    const fields: ModalDataField[] = [
        {
            label: 'Имя пользователя',
            value: current?.full_name ?? '',
            type: 'text',
        },
        { label: 'ID Telegram', value: current?.chat_id ?? '', type: 'text' },
        { label: 'Юзернэйм', value: current?.user_name ?? '', type: 'text' },
        { label: 'Сценарий', value: current?.type_label ?? '', type: 'text' },
        {
            label: 'Дата отправки',
            value: current?.created_at ?? '',
            type: 'date',
        },
        { label: 'Статус', value: current?.status ?? '', type: 'text' },
        {
            label: 'Причина ошибки',
            value: current?.error_message ?? '',
            type: 'text',
        },
    ];

    return (
        <GenericModal
            title={current?.type_label ?? ''}
            width={720}
            open
            onCancel={() => navigate(-1)}
            destroyOnClose
            footer={null}
        >
            <div style={{ marginTop: '32px' }}>
                <Flex
                    style={{
                        borderBottom: '1px solid #ebebeb',
                        padding: '16px 0',
                    }}
                    vertical
                >
                    {current?.content?.media_url && (
                        <Flex>
                            <S.ModalImageWrapper>
                                <S.ModalImage
                                    src={current?.content?.media_url}
                                />
                            </S.ModalImageWrapper>
                        </Flex>
                    )}
                    <Flex>
                        <Text>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: current?.content?.message,
                                }}
                            ></span>
                        </Text>
                    </Flex>
                </Flex>

                {fields.map(({ label, value, type }) => (
                    <Flex
                        key={label}
                        style={{
                            borderBottom: '1px solid #ebebeb',
                            padding: '16px 0',
                        }}
                    >
                        <Col span={12}>
                            <Text>{label}</Text>
                        </Col>
                        <Col span={12}>
                            <Text>
                                {type === 'date' ? (
                                    dayjs(value).format('DD.MM.YYYY, HH:mm')
                                ) : label === 'Статус' ? (
                                    <Tag>{String(value)}</Tag>
                                ) : (
                                    String(value)
                                )}
                            </Text>
                        </Col>
                    </Flex>
                ))}
            </div>
        </GenericModal>
    );
};
